import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
import { STARTING_TABLE_PAGE, DEFAULT_ROWS_PER_PAGE, } from '../Utils/Constants';
const sControllerEndpoint = 'SalesForceAudit';


export class SalesForceAPI {

  getQueueList(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, searchBy = '') {
    let params = {
      page: page,
      rowsPerPage: rowsPerPage
    }
    if (searchBy)
      params.searchBy = searchBy;
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetQueueList', { params });
  }

  getSyncQueue() {
    return axios.post(getBackendURL() + sControllerEndpoint + '/GetSyncQueue');
  }

  getAuditBMSF(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, searchBy = '') {
    let params = {
      page: page,
      rowsPerPage: rowsPerPage
    }
    if (searchBy)
      params.searchBy = searchBy;
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetAuditBMSF', { params });
  }

  getAuditSFBM(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, searchBy = '') {
    let params = {
      page: page,
      rowsPerPage: rowsPerPage
    }
    if (searchBy)
      params.searchBy = searchBy;
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetAuditSFBM', { params });
  }

  cancelSyncQueue(queueId) {
    return axios.post(getBackendURL() + sControllerEndpoint + '/CancelSyncQueue?queueId=' + queueId);
  }
}

export default SalesForceAPI


// WEBPACK FOOTER //
// ./src/API/SalesForceAPI.js